import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SlotsService } from '@services/slots/slots.service';

export interface DialogData {

  client: any;
  cameraId: string;
}

@Component({
  selector: 'app-smartparking-slots-add',
  templateUrl: './smartparking-slots-add.component.html',
  styleUrls: ['./smartparking-slots-add.component.scss']
})
export class SmartparkingSlotsAddComponent implements OnInit {

  confirmAdd = false;

  constructor(
    public dialogRef: MatDialogRef<SmartparkingSlotsAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private slotsService: SlotsService

  ) { }

  ngOnInit(): void {
  }

  addSlot(): void {
    this.confirmAdd = true;
    this.slotsService.addSlot(this.data.cameraId).subscribe(() => {
      setTimeout(() => {
        this.confirmAdd = false;
        this.dialogRef.close();
      }, 3000);
    });
  }


}
